import underscored from 'underscore.string/underscored';

angular
  .module 'gym.components'
  .directive 'ezidebitPaymentDetails', ->
    restrict: 'EA'
    scope:
      paymentMethods: '='
      permissions: '='
      contact: '='
      remove: '&'
    template: require('templates/components/contacts/wallet/ezidebit_payment_details.html.slim')
    controller: ($scope, AdminUserService) ->
      $scope.adminHasPermission = AdminUserService.has
      $scope.contactsType = (type) ->
        "#{underscored(type)}s"
